export default __webpack_public_path__ + "static/state-revenue-by-source-2021-dbd8538d183e35eddf28440cf59a5b5b.pdf";